import React from 'react';
import Icon from "./Icon";

const IconPerson = ({tooltip, number_of_people}) => {
    return (
        <Icon
            style={{position: 'relative'}}
            image="/img/icons/icon-person.svg"
            tooltip={tooltip}
        >
            {number_of_people !== null &&
            <span className="apartment-people-amount">
                {number_of_people}
            </span>
            }
        </Icon>
    )
};

export default IconPerson;